export var CommercialFeatureFlags;
(function (CommercialFeatureFlags) {
    CommercialFeatureFlags["Embedding"] = "embedding";
    CommercialFeatureFlags["Scim"] = "scim-token-management";
    CommercialFeatureFlags["AiCopilot"] = "ai-copilot";
    CommercialFeatureFlags["ServiceAccounts"] = "service-accounts";
    CommercialFeatureFlags["OrganizationWarehouseCredentials"] = "organization-warehouse-credentials";
    CommercialFeatureFlags["AgentReasoning"] = "agent-reasoning";
    CommercialFeatureFlags["MultiAgentChannel"] = "multi-agent-channel";
})(CommercialFeatureFlags || (CommercialFeatureFlags = {}));
//# sourceMappingURL=commercialFeatureFlags.js.map